import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { QPATResponse, UmsResponse } from 'qp-ui-interface';
import { isTokenExpired, manageResponse } from 'qp-utility';
import { map } from 'rxjs/operators';
import { LocalStorageKeys } from '../../LocalStorageKeys';
import { hasSelectedProfile } from '../../utils/LoginUtils';
import { saveXAuthToken } from '../../utils/tokenUtils';
import { ConfigService } from '../config/config.service';
import { LocalStorageService } from '../local-storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class QPATService {
  constructor(private http: HttpClient, private configService: ConfigService, private localStorage: LocalStorageService) {}

  getQPAT(): Promise<QPATResponse> {
    return this.http
      .post<UmsResponse>(`${this.configService.applicationConfig.qpatURL}`, {
        deviceId: this.localStorage.getItem(LocalStorageKeys.DEVICEREF),
        profileId: this.localStorage.getItem(LocalStorageKeys.SELECTED_PROFILE_ID),
      })
      .pipe(map((res) => manageResponse<QPATResponse>(res)))
      .toPromise();
  }

  async refreshXAuthToken(): Promise<void> {
    if (!hasSelectedProfile(this.localStorage)) {
      return Promise.resolve();
    }
    if (isTokenExpired(this.localStorage.getItem(LocalStorageKeys.XAUTH_TOKEN_EXP))) {
      const result = await this.getQPAT();
      saveXAuthToken(result, this.localStorage);
    }
  }
}
